import React from "react";
import {Pagination} from "antd";
import type {AppPaginationProps} from "./Pagination.types";

export const AppPagination = (props: AppPaginationProps) => {
  return <Pagination {...props}/>;
};